/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const BoldIcon = /*#__PURE__*/ createSvgIcon(
  'BoldIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M7.042 16c-.413 0-.766-.147-1.06-.44a1.445 1.445 0 01-.44-1.06v-9c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h3.25c.928 0 1.786.287 2.571.86.786.575 1.179 1.371 1.179 2.39 0 .708-.156 1.26-.469 1.656-.313.396-.608.685-.885.866.36.166.75.464 1.166.895.417.43.625 1.062.625 1.896 0 1.263-.466 2.152-1.397 2.666-.932.514-1.807.771-2.624.771H7.042zm1.146-2.458h2.18c.671 0 1.076-.17 1.215-.51.14-.341.209-.588.209-.74 0-.153-.073-.4-.219-.74-.146-.34-.573-.51-1.281-.51H8.188v2.5zm0-4.834h1.937c.458 0 .795-.121 1.01-.364.216-.243.323-.504.323-.781a1.03 1.03 0 00-.356-.813c-.238-.208-.545-.313-.922-.313H8.188v2.271z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default BoldIcon;
